import { selector } from "recoil";

import { CustomFieldDto } from "../../../dto";
import { Log } from "../../../helpers";
import { customFieldsAtom } from "../../atoms";
import { companyIdSelector } from "../profile.selectors";

export const customFieldsSelector = selector<CustomFieldDto[]>({
  key: "customFieldsSelector",
  get: ({ get }) => {
    const companyId = get(companyIdSelector);
    const customFieldsDtos = get(customFieldsAtom);
    Log.debug("List of customFields fetched", customFieldsDtos);

    return (
      customFieldsDtos?.filter(
        x => !x.companyId || x.companyId === companyId,
      ) || []
    );
  },
});
